import { EventBuilder } from './EventBuilder';
import { DDNAEvents } from './Tracker';

export enum AdTypes {
    INTERSTITIAL = 'interstitial',
    REWARDED = 'rewarded',
}

export enum AdGameAreas {
    MAP = 'map',
    LEVEL = 'level',
}

export enum AdContexts {
    LOSS_AVERSION = 'loss aversion',
    WIN_SEQUENCE = 'win sequence',
    MAP_WHEEL = 'map wheel',
    MISSION_SKIP = 'mission skip',
    COINS_NEEDED = 'coins needed',
    LIFE_NEEDED = 'life needed',
    NONE = 'none',
}

export enum AdRewardTypes {
    EXTRA_SPIN = 'extra spin',
    COINS = 'coins',
    EXTRA_GIFTS = 'extra gifts',
    LIFE = 'life',
    NONE = 'none',
}

export interface IAdParamsFromGame {
    adGameArea: AdGameAreas;
    adRewardType: AdRewardTypes;
    adContext: AdContexts;
    adMissionID: number;
    adLevelID: string;
    adLevelNum: number;
}

export interface IAdParamsFromAdWrapper {
    adType: AdTypes;
    placementID: string;
    adID: string;
    adName: string;
    adProvider: string; //.
    adRequestTimeMs: number; //.
    // TODO try to include ad error - null if nothing
}

export interface IAdParams extends IAdParamsFromGame, IAdParamsFromAdWrapper {}

export class AdParamBuilder extends EventBuilder {
    private curAdParams: IAdParamsFromGame;

    constructor() {
        super();
    }

    public setParamsFromGame(data: IAdParamsFromGame): void {
        this.curAdParams = data;
    }

    public getParams<T>(event: DDNAEvents, data: IAdParamsFromAdWrapper): IAdParams {
        return {
            ...data,
            ...this.curAdParams,
        };
    }

    // state updated params here
    public setParams(keys: Map<string, unknown>): void {
        keys.forEach(key => {});
    }
}
